import type * as React from 'react';

const OCLogo = (props: Record<string, React.SVGProps<SVGElement>>) => (
  <svg
    data-testid="oc-logo"
    fill="none"
    height="50"
    viewBox="0 0 400 400"
    width="50"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 0h400v400H0z" fill="#022e4a" />
    <path
      d="M146.408 142.92C115.256 142.92 90 168.472 90 200.001c0 31.528 25.256 57.087 56.408 57.087s56.409-25.559 56.409-57.087-25.256-57.081-56.409-57.081m0 85.564c-15.542 0-28.141-12.75-28.141-28.483s12.599-28.477 28.141-28.477c15.543 0 28.142 12.75 28.142 28.477s-12.599 28.483-28.142 28.483M310 154.565l-11.157 23.554c-5.703-4.959-13.388-8.43-25.29-8.43-20.082 0-31.24 13.884-31.24 30.248s11.158 30.25 31.24 30.25c11.902 0 19.091-3.72 25.29-8.679L310 245.311c-9.173 5.951-22.067 11.654-37.935 11.654-36.447 0-59.753-24.299-59.753-57.028s23.307-57.025 59.753-57.025c15.868 0 29.01 5.455 37.935 11.653"
      fill="#fff"
    />
  </svg>
);
export default OCLogo;
